const parseAcl = operationalAcl => ({
  internalAcl: operationalAcl.filter(acl => !acl.isExternal),
  externalAcl: operationalAcl.filter(acl => acl.isExternal)
});

export default parseAcl;
